/* global SideDrawer, trapFocus, removeTrapFocus */

if (!customElements.get('product-description-drawer')) {
  class ProductDescriptionDrawer extends SideDrawer {
    constructor() {
      super();
      // Move drawer to body level for proper viewport positioning
      this.moveToBody();
      this.init();
    }

    /**
     * Moves the drawer element to the body for viewport-relative positioning
     */
    moveToBody() {
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
      }
    }

    /**
     * Override open to add background styling to overlay
     */
    open(opener, elementToFocus, callback) {
      super.open(opener, elementToFocus, callback);
      // Add dark blurred background to overlay
      if (this.overlay) {
        this.overlay.style.setProperty('background', 'rgba(0, 0, 0, 0.4)', 'important');
        this.overlay.style.setProperty('opacity', '1', 'important');
        this.overlay.style.setProperty('backdrop-filter', 'blur(4px)', 'important');
        this.overlay.style.setProperty('-webkit-backdrop-filter', 'blur(4px)', 'important');
      }
    }

    /**
     * Override close to remove background styling from overlay
     */
    close(callback) {
      // Remove custom background styling
      if (this.overlay) {
        this.overlay.style.removeProperty('background');
        this.overlay.style.removeProperty('opacity');
        this.overlay.style.removeProperty('backdrop-filter');
        this.overlay.style.removeProperty('-webkit-backdrop-filter');
      }
      super.close(callback);
    }

    disconnectedCallback() {
      // Clean up event listeners
      const buttons = document.querySelectorAll('.js-open-description-drawer');
      buttons.forEach(button => {
        button.removeEventListener('click', this.handleOpenClick);
      });

      if (Shopify.designMode) {
        document.removeEventListener('shopify:section:select', this.sectionSelectHandler);
        document.removeEventListener('shopify:section:deselect', this.sectionDeselectHandler);
      }
    }

    init() {
      // Find all buttons that open this specific drawer
      const drawerId = this.id;
      const buttons = document.querySelectorAll(`.js-open-description-drawer[data-drawer-id="${drawerId}"]`);
      
      buttons.forEach(button => {
        button.setAttribute('role', 'button');
        button.setAttribute('aria-haspopup', 'dialog');

        button.addEventListener('click', (evt) => {
          evt.preventDefault();
          this.open(button);
        });

        button.addEventListener('keydown', (evt) => {
          if (evt.key !== ' ') return;
          evt.preventDefault();
          this.open(button);
        });
      });

      // Shopify Theme Editor support
      if (Shopify.designMode) {
        this.sectionSelectHandler = this.handleSectionSelect.bind(this);
        this.sectionDeselectHandler = this.handleSectionDeselect.bind(this);
        document.addEventListener('shopify:section:select', this.sectionSelectHandler);
        document.addEventListener('shopify:section:deselect', this.sectionDeselectHandler);
      }
    }

    /**
     * Handle when the section is selected in the Theme Editor
     * @param {object} evt - Event object.
     */
    handleSectionSelect(evt) {
      if (evt.target === this.closest('.shopify-section')) this.open();
    }

    /**
     * Handle when the section is de-selected in the Theme Editor
     * @param {object} evt - Event object.
     */
    handleSectionDeselect(evt) {
      if (evt.target === this.closest('.shopify-section')) this.close();
    }
  }

  customElements.define('product-description-drawer', ProductDescriptionDrawer);
}
